import {
  Card,
  Col,
  Row,
  Typography,
  Button,
  Table,
} from "antd";
import { useEffect, useState } from "react";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import {
  FileOutlined,
  ClockCircleOutlined,
  PieChartOutlined,
  UserOutlined,
  QuestionCircleOutlined,
  BarChartOutlined,
  RocketOutlined,
  DesktopOutlined,
} from "@ant-design/icons";
import { values } from "lodash";

const { Title, Paragraph } = Typography;

function DashboardIndex() {
  const { request } = useRequest();
  const [dashboardData, setDashboardData] = useState({
    totalDevice: 0,
    upcomingSchedules: 0,
    totalContact: 0,
  });

  useEffect(() => {
    request({
      url: apiPath.dashboard,
      method: "GET",
      onSuccess: (data) => {
        console.log(data);
        setDashboardData({
          totalDevice: data.data.totalDevice || 0,
          user: data.data.totalUser || {},
          question: data.question || {},
        });
      },
    });
  }, []);

  const engagementStats = [
    { label: "Riyadh", value: "3,200", color: "#7B83EB" },
    { label: "Jeddah", value: "2,750", color: "#A78BFA" },
    { label: "Dammam", value: "1,800", color: "#6366F1" },
  ];

  const contentColumns = [
    {
      title: "FILE/DOCUMENT",
      dataIndex: "file",
    },
    {
      title: "DESCRIPTION",
      dataIndex: "description",
    },
    {
      title: "ACTION",
      dataIndex: "action",
    },
  ];

  const contentData = [
    {
      key: "1",
      file: "No Document",
      description: "Hello Sir",
      action: <Button icon={<FileOutlined />} />,
    },
  ];

const statCards = [
  {
    label: "Number of Responded Voice Messages",
    // subLabel: "Today / This Week / This Month",
    icon: <ClockCircleOutlined />,
    value: dashboardData.user?.totalVoiceMessage || 0,
  },
  {
    label: "Voice System Response Rate",
    // subLabel: "Avg Time to Respond (in Seconds)",
    icon: <PieChartOutlined />,
    value: dashboardData.user?.totalReponsedMessage || 0,
  },
  {
    label: "Number of Customers Engaged with Voice Chat",
    // subLabel: "Customers who interacted with voice service",
    icon: <UserOutlined />,
    value: dashboardData.user?.totalCustomerCount || 0,
  },
  {
    label: "Most Frequently Asked Questions",
    // subLabel: "Common topics raised by customers",
    icon: <QuestionCircleOutlined />,
  },
 

  {
    label: "Number of Devices Connected to the System",
    // subLabel: "Computers, mobiles, POS systems etc.",
    icon: <DesktopOutlined />,
    value: dashboardData.totalDevice || 0,
  },
];


  return (
    <div>
      {/* TOP STATISTICS */}
      <Card title="Section one : Voice System Overview">
        <Row gutter={[16, 16]}>
        {statCards.map((item, idx) => (
          <Col xs={24} sm={12} md={8} lg={6} key={idx}>
            <Card className="voice-systum-card-main">
              <div className="voice-systum-card-main-inner">
               <div>
                 <h5>{item.label}</h5>
                <p>{item.value}</p>
               </div>
                <div style={{ fontSize: 20 }}>{item.icon}</div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
      </Card>

      <Row gutter={[24, 24]} className="mt-3">
       
        <Col xs={24} md={12}>
          <Card
            title="Top Geographical Areas by Engagement"
            style={{ borderRadius: 12 }}
          >
            <Paragraph>
              List of Top 5 Regions with Highest Voice Chat Interactions
              <br />
              (Based on number of messages or unique customers)
            </Paragraph>
            <div
              style={{
                width: 160,
                height: 160,
                borderRadius: "50%",
                background: "conic-gradient(#00c4cc 0% 54%, #3d4bd9 0% 100%)",
                margin: "0 auto",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  width: 90,
                  height: 90,
                  background: "#fff",
                  borderRadius: "50%",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
              >
                60
              </div>
            </div>
          </Card>
        </Col>

      
        <Col xs={24} md={12}>
          <Card style={{ borderRadius: 12 }}>
            <Title level={4} style={{ color: "#4f46e5" }}>
              Engagement Indicator per Region Example
            </Title>
            {engagementStats.map((stat) => (
              <Paragraph key={stat.label} style={{ fontSize: 16 }}>
                <span style={{ color: stat.color, fontWeight: 600 }}>
                  ● {stat.label}
                </span>{" "}
                <strong>{stat.value} messages</strong>
              </Paragraph>
            ))}
            <Paragraph style={{ marginTop: 16, fontSize: 14 }}>
              <strong>Bar Chart Displaying Interaction Volume per Region</strong> <br />
              (Visual comparison of regional activity) <br />
              Monthly Engagement Growth Rate per Region
            </Paragraph>
          </Card>
        </Col>
      </Row>
      {/* <Card
        title="Content Manager"
        className="mt-3"
        extra={<Button type="primary" className="fill-btn">+ Add Content</Button>}
      >
        <Table
          columns={contentColumns}
          dataSource={contentData}
          pagination={false}
          bordered
        />
      </Card> */}
    </div>
  );
}

export default DashboardIndex;
